module.exports = "/assets/f6a874eb12dfb582967a1bdce439decc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IM.png
// module id = 1479
// module chunks = 0